// import React from "react";
import { createMedia } from "@artsy/fresnel";

const polarMedia = createMedia({
  breakpoints: {
    // sm: 0,
    // md: 768,
    // lg: 1024,
    // xl: 1192,

    xs: 320,
    ms: 570,
    sm: 720,

    md: 1024,
    tab: 1259,
    l: 1536,
  },
});

export const mediaStyles = polarMedia.createMediaStyle();

export const { Media, MediaContextProvider } = polarMedia;
